const feedbackSelectorClass = 'at-feedback';

const toggleFeedbackAccordion = (accordion, userEvent) => {
  userEvent.preventDefault();

  const isCollapsed = accordion && accordion.classList.contains(`${feedbackSelectorClass}__accordion--collapsed`);
  const itemsList = document.querySelectorAll(`.${feedbackSelectorClass}__accordion-items`);
  const icon = accordion.querySelector(`.${feedbackSelectorClass}__accordion-icon`);
  const spanText = accordion.querySelector('span');

  if (isCollapsed) {
    accordion.classList.remove(`${feedbackSelectorClass}__accordion--collapsed`);
    itemsList.forEach((items) => {
      items.classList.remove(`${feedbackSelectorClass}__accordion-items--collapsed`);
    });
    icon.classList.remove(`${feedbackSelectorClass}__accordion-icon--collapsed`);
    spanText.innerText = spanText.innerText.replace('Show', 'Hide');
    return;
  }

  accordion.classList.add(`${feedbackSelectorClass}__accordion--collapsed`);
  itemsList.forEach((items) => {
    items.classList.add(`${feedbackSelectorClass}__accordion-items--collapsed`);
  });
  icon.classList.add(`${feedbackSelectorClass}__accordion-icon--collapsed`);
  spanText.innerText = spanText.innerText.replace('Hide', 'Show');
};

const initializeFeedbackAccordion = () => {
  document.querySelectorAll(`.${feedbackSelectorClass}__accordion`)
    .forEach((accordion) => {
      accordion.addEventListener('click', (userEvent) => toggleFeedbackAccordion(accordion, userEvent));
    });
};

export { toggleFeedbackAccordion, initializeFeedbackAccordion };
